
import style from "./Header.module.scss";

import { useWindowSize } from "../../utils";
import { DesktopHeader } from "./DesktopHeader/DesktopHeader";
import { MobileHeader } from "./MobileHeader/MobileHeader";



export const Header = () => {
  
  const { width } = useWindowSize();
  
  return (
    // Создал 2 хэддера 1 от другого отличается вставленной картинкой и выравниванием (класс jcSb)
    <>
      {(width && width > 770 )? <DesktopHeader /> : <MobileHeader />}
</>
  );
};




